import React from "react";

function ServicePricing() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-in">
        <h1>Servicing Policy</h1>

        <h2>Service Availability</h2>
        <p>
          We provide servicing for products that qualify under our service
          policy. Service availability may vary based on product type and
          warranty coverage.
        </p>

        <h2>Service Request Process</h2>
        <p>
          Customers can request servicing by contacting our support team at +91
          9638666602 or emailing care@deodap.com with order details and issue
          description.
        </p>

        <h2>Service Charges</h2>
        <p>
          Service charges depend on the type of servicing required and whether
          the product is under warranty. Out-of-warranty products will be
          subject to additional charges.
        </p>

        <h2>Turnaround Time</h2>
        <p>
          The estimated service completion time varies based on the issue and
          service center workload. Customers will be notified of the expected
          timeline upon service request.
        </p>

        <h2>Replacement Policy</h2>
        <p>
          If a product cannot be repaired, replacement options may be provided
          based on our replacement policy and warranty terms.
        </p>

        <h2>Customer Responsibilities</h2>
        <p>
          Customers must provide accurate product details and cooperate in
          troubleshooting. Incomplete or incorrect details may delay servicing.
        </p>

        <h2>9. Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>Name: CGTHomes </p>
    <p>Email: info@cgthomes.com</p>
    <p>Company Email: support@cgthomes.com</p>
    <p>Company Address: Street No 3, DLF Cyber City Hyderabad, telengana</p>

      </div>
    </div>
  );
}

export default ServicePricing;
